import { Button } from '@release/guest_ui/Button';
import { Icon } from '@release/guest_ui/Icon';
import { IconButton } from '@release/guest_ui/IconButton';
import { Modal } from '@release/guest_ui/Modal';
import { ReleaseLogo } from '@release/guest_ui/ReleaseLogo';
import { Typography } from '@release/guest_ui/Typography';
import { foldModal, isModalOpen, ModalState } from '@release/shared/utils/modal';
import { useState } from 'react';

export type NewOrgInvitationModalState = ModalState<{
  orgName: string;
  groupNames: string[];
  onAccept: () => Promise<void>;
}>;

type NewOrgInvitationModalProps = {
  state: NewOrgInvitationModalState;
  onClose: () => void;
};

export const NewOrgInvitationModal: React.FC<NewOrgInvitationModalProps> = ({ state, onClose }) => {
  const [isAccepting, setIsAccepting] = useState(false);
  const handleAccept = async (onAccept: () => Promise<void>) => {
    if (isAccepting) return;
    setIsAccepting(true);
    try {
      await onAccept();
    } finally {
      setIsAccepting(false);
    }
  };
  return (
    <Modal isOpen={isModalOpen(state)}>
      {foldModal(
        state,
        () => null,
        ({ orgName, onAccept }) => (
          <div className="relative flex w-full flex-col items-center gap-y-6 px-6 pb-8 pt-14">
            <div className="absolute right-4 top-4">
              <IconButton name="close" size="md" onClick={onClose} />
            </div>
            <ReleaseLogo width={200} height={30} />
            <div className="flex flex-col items-center">
              <Typography className="text-sem-l-text-high" size="cat">
                レリーズIDを
              </Typography>
              <Typography className="text-sem-l-text-high" weight="bold" size="cat">
                {orgName}
              </Typography>
              <Typography className="text-sem-l-text-high" size="cat">
                に連携します
              </Typography>
            </div>
            <div className="flex flex-col gap-2 rounded border border-sem-l-divider-medium p-4">
              <div className="flex items-center gap-2">
                <Icon name="info" />
                <Typography size="rabbit">以下の情報が上記の事業者に提供されます</Typography>
              </div>
              <div className="flex flex-col">
                <Typography size="rabbit">・氏名(法人の場合は、法人名・担当者)</Typography>
                <Typography size="rabbit">・メールアドレス</Typography>
                <Typography size="rabbit">・生年月日</Typography>
                <Typography size="rabbit">・電話番号</Typography>
              </div>
              <Typography size="rabbit">※過去のお取引内容は提供されません</Typography>
            </div>
            <Button
              size="md"
              label="同意して連携する"
              className="w-full"
              onClick={() => void handleAccept(onAccept)}
              type="button"
              disabled={isAccepting}
              isLoading={isAccepting}
            />
          </div>
        )
      )}
    </Modal>
  );
};
